import clientAxios from "../../client";

import { formatQueryString } from "@/common/utils/common";

import type {
  EvaluationPayloadType,
  EvaluationType,
} from "@/common/types/evaluation";

export async function evaluationList(
  account_id: string,
  query?: { [key: string]: any },
) {
  const queryString = formatQueryString(query);

  return await clientAxios.get(
    `account/${account_id}/evaluation/list${queryString}`,
  );
}

export async function evaluationShow(
  account_id: string,
  evaluation_id: string,
) {
  return await clientAxios.get(
    `account/${account_id}/evaluation/${evaluation_id}/show`,
  );
}

export async function evaluationCreate(
  account_id: string,
  payload: EvaluationPayloadType,
) {
  return await clientAxios.post(
    `account/${account_id}/evaluation/create`,
    payload,
  );
}

export async function evaluationUpdate(
  account_id: string,
  evaluation_id: string,
  payload: EvaluationPayloadType,
) {
  return await clientAxios.put(
    `account/${account_id}/evaluation/${evaluation_id}/update`,
    payload,
  );
}

export async function evaluationPatch(
  account_id: string,
  evaluation_id: string,
  payload: Partial<EvaluationType>,
) {
  return await clientAxios.patch(
    `account/${account_id}/evaluation/${evaluation_id}/patch`,
    {
      payload,
    },
  );
}

export async function evaluationDelete(
  account_id: string,
  evaluation_id: string,
) {
  return await clientAxios.del(
    `account/${account_id}/evaluation/${evaluation_id}/delete`,
  );
}

export async function evaluationStart(
  account_id: string,
  evaluation_id: string,
) {
  return await clientAxios.post(
    `account/${account_id}/evaluation/${evaluation_id}/start`,
    {},
  );
}

export async function evaluationCancel(
  account_id: string,
  evaluation_id: string,
) {
  return await clientAxios.post(
    `account/${account_id}/evaluation/${evaluation_id}/cancel`,
    {},
  );
}

export async function evaluationFinish(
  account_id: string,
  evaluation_id: string,
) {
  return await clientAxios.post(
    `account/${account_id}/evaluation/${evaluation_id}/finish`,
    {},
  );
}
